import { render, staticRenderFns } from "./floatBlock.vue?vue&type=template&id=1cd53f67&scoped=true&"
import script from "./floatBlock.vue?vue&type=script&lang=js&"
export * from "./floatBlock.vue?vue&type=script&lang=js&"
import style0 from "./floatBlock.vue?vue&type=style&index=0&id=1cd53f67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd53f67",
  null
  
)

export default component.exports